import React from "react";
import ReactECharts from "echarts-for-react";

const BarChart = ({ chart }) => {

const option = {
  tooltip: {
    trigger: "axis",
  },

  grid: {
    left: 20,
    right: 30,
    top: 0,
    bottom: 20,
    containLabel: true,
  },

  xAxis: {
    type: "value",
  },

  yAxis: {
    type: "category",
    data: chart.data.map(item => item.name),
    axisLabel: {
      width: 140,
      overflow: "truncate",
    },
  },

  series: [
    {
      type: "bar",
      data: chart.data.map(item => item.value),
      barWidth: 20,
      itemStyle: {
        borderRadius: [0, 8, 8, 0],
      },
    },
  ],
};

  return (
    <ReactECharts
      option={option}
      style={{ height: 350 }}
    />
  );
};

export default BarChart;